import { render, staticRenderFns } from "./L1_scroll.vue?vue&type=template&id=5e3debe3&scoped=true&"
import script from "./L1_scroll.vue?vue&type=script&lang=js&"
export * from "./L1_scroll.vue?vue&type=script&lang=js&"
import style0 from "./L1_scroll.vue?vue&type=style&index=0&id=5e3debe3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3debe3",
  null
  
)

export default component.exports